import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportCourseCSV } from "../../appRedux/actions/courses";
import { apiURL } from "../../utils/config";
function DownloadCSV({ checkedColumns }) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { queryInfo } = useSelector((state) => ({
    queryInfo: state.courses.queryInfo,
  }));
  const handleDownload = async () => {
    setLoader(true);

    // Build export params from the current queryInfo (which contains the active filters)
    const { page, size, next, ...filterParams } = queryInfo;

    // Append visible columns if user has customised the column selection
    if (checkedColumns && checkedColumns.length > 0) {
      filterParams.columns = checkedColumns.join(",");
    }

    dispatch(
      exportCourseCSV(filterParams)
    )
      .then((data) => {
        // Step 2: Create a Blob from the CSV data
        const url = window.URL.createObjectURL(
          new Blob([data], { type: "text/csv" })
        );
        // Step 3: Create a link to download the Blob
        const a = document.createElement("a");
        a.href = url;
        a.download = "course.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();

        // Revoke the object URL after the download is complete
        window.URL.revokeObjectURL(url);
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  return (
    <Fragment>
      <a
        className="btn add-btn  m-r-5"
        onClick={() => (loader ? "" : handleDownload())}
        // href={`${apiURL}/v1/exportData`}
      >
        {loader ? (
          <i class="fas fa-spinner fa-spin me-2" />
        ) : (
          <i className="fas fa-file-export" />
        )}{" "}
        Export
      </a>
    </Fragment>
  );
}

export default DownloadCSV;
